import { PageHeader } from "@/components/PageHeader";
import { Section, Eyebrow } from "@/components/kit";
import { Reveal, Stagger, StaggerItem } from "@/components/motion";
import { ContactForm } from "@/components/ContactForm";
import { DuoBanner } from "@/components/DuoBanner";
import { Heart, Gift, MessagesSquare, Star, Camera, Music, MapPin, Sparkles } from "lucide-react";
import { IMG } from "@/data/content";

const perks = [
  { icon: Star, t: "Acceso Anticipado", d: "Entérate 24 horas antes de cada episodio." },
  { icon: Gift, t: "Sorteos de merch exclusivo", d: "Premios firmados por Anto & Bella." },
  { icon: MessagesSquare, t: "Comunidad activa", d: "Comenta y comparte cada viaje." },
  { icon: Heart, t: "Contenido extra", d: "Momentos que no salieron en TV." },
  { icon: Camera, t: "Detrás de cámaras", d: "Fotos y clips que no llegaron a la tele." },
  { icon: MapPin, t: "Mapa de la ruta", d: "Sigue cada destino en tiempo real." },
  { icon: Music, t: "Playlist oficial", d: "La música de cada episodio, para ti." },
  { icon: Sparkles, t: "Retos Especiales QR", d: "Participa y gánate un shout-out." },
  { icon: Sparkles, t: "Chat directo", d: "Canal de comunidad donde Anto y Bella responden mensajes de verdad." },
  { icon: Sparkles, t: "Fotos sin publicar", d: "Galería mensual con las fotos más personales y espontáneas del viaje." },
];

export default function Believers() {
  return (
    <>
      <PageHeader
        eyebrow="Comunidad · Believers"
        eyebrowColor="#A8E6CF"
        title={["Únete a los", "Believers."]}
        subtitle="Los Believers somos los que creemos en Anto & Bella antes de que el mundo las conozca. Somos la comunidad que viaja con ellas, quienes siguen cada episodio, cada reto y cada momento real, sigue la conversación después y siempre lista para la próxima aventura."
      />

      <section className="px-5 sm:px-8 lg:px-12 pt-4 pb-6">
        <div className="mx-auto max-w-7xl">
          <Reveal className="relative overflow-hidden rounded-[2.5rem] shadow-[0_20px_40px_rgb(0,0,0,0.08)]">
            <img
              src={IMG.duoBelieversFans}
              alt="Anto y Bella con la comunidad de Believers"
              className="w-full object-cover"
              data-testid="believers-hero-image"
            />
            <span className="absolute left-5 top-5 rounded-full bg-cream/90 px-4 py-1.5 font-mono text-[11px] font-bold uppercase tracking-widest text-ink">
              La comunidad Believer
            </span>
          </Reveal>
        </div>
      </section>

      <Section className="!pt-6">
        <div className="grid gap-12 lg:grid-cols-[1.1fr_0.9fr]">
          <div>
            <Stagger className="grid gap-4 sm:grid-cols-2">
              {perks.map((p) => (
                <StaggerItem
                  key={p.t}
                  className="rounded-[1.5rem] bg-white p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)]"
                >
                  <p.icon className="h-7 w-7 text-coral" />
                  <h3 className="mt-4 font-display text-lg font-bold text-ink">{p.t}</h3>
                  <p className="mt-1 text-sm text-ink/60 leading-relaxed">{p.d}</p>
                </StaggerItem>
              ))}
            </Stagger>
            <div className="mt-6 rounded-[1.5rem] bg-mint/40 p-7">
              <p className="font-display text-2xl font-bold text-ink">100% gratis</p>
              <p className="mt-2 text-ink/70 leading-relaxed">
                Ser Believer no cuesta nada. Solo ganas de viajar con nosotras y
                de compartir la aventura con otras familias curiosas. No es un club de fans. Es un grupo de personas que creen que viajar con curiosidad es la mejor forma de crecer. Si eso te suena, ya eres parte.
              </p>
            </div>
          </div>

          <Reveal delay={0.1}>
            <div className="rounded-[2rem] bg-white p-8 shadow-[0_20px_40px_rgb(0,0,0,0.08)]">
              <Eyebrow color="#A8E6CF">Únete gratis</Eyebrow>
              <h2 className="mt-3 font-display text-3xl font-extrabold tracking-tight text-ink">
                Hazte Believer
              </h2>
              <p className="mt-2 mb-6 text-sm text-ink/60">
                Déjanos tus datos y te avisamos de cada estreno.
              </p>
              <ContactForm
                testidPrefix="believers"
                sourcePath="/believers"
                combo="Unirme a Believers (gratis)"
                accent="#A8E6CF"
                submitLabel="Quiero ser Believer"
                successMsg="¡Bienvenida, Believer!"
                fields={[
                  { name: "nombre", label: "Tu nombre", placeholder: "¿Cómo te llamas?" },
                  { name: "email", label: "Email", type: "email", placeholder: "tucorreo@email.com" },
                  { name: "ciudad", label: "Ciudad", placeholder: "¿Desde dónde nos ves?", required: false },
                ]}
              />
            </div>
          </Reveal>
        </div>
      </Section>

      <DuoBanner
        image={IMG.duoBelievers}
        imgSide="left"
        alt
        tint="#A8E6CF"
        eyebrowColor="#A8E6CF"
        title="Bienvenida a la familia viajera."
        text="Ser Believer es viajar con nosotras aunque estés en el sillón. Anto y Bella te mandan un abrazo (y muchas ganas de aventura)."
        cta={{ to: "/vip", label: "Sube a Área VIP", variant: "coral" }}
      />
    </>
  );
}
